import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  light?: boolean; // Kept for API compatibility, but mostly ignored in dark theme
}
export function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center'
}: SectionHeaderProps) {
  return <div className={`mb-16 relative z-10 ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-162">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className={`flex items-center gap-3 mb-4 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-163">
        {align === 'center' && <span className="w-8 h-[1px] bg-gradient-to-r from-transparent to-gold/50" data-id="element-164"></span>}
        <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-gold" data-id="element-165">
          {eyebrow}
        </span>
        <span className={`w-8 h-[1px] bg-gradient-to-l from-transparent to-gold/50 ${align === 'left' ? 'hidden' : ''}`} data-id="element-166"></span>
        {align === 'left' && <span className="w-12 h-[1px] bg-gradient-to-r from-gold/50 to-transparent" data-id="element-167"></span>}
      </motion.div>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className="text-4xl md:text-5xl lg:text-6xl mb-6 text-white" data-id="element-168">
        {title}
      </motion.h2>

      {description && <motion.p initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2
    }} className={`text-lg md:text-xl max-w-2xl text-balance text-beige-muted ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-169">
          {description}
        </motion.p>}
    </div>;
}